import React from 'react';

export default () => (
  <section className='container-fluid'>
          <div className='row m-2-hor'>
            
            <div className='col-md-6 pt-5'>
              <div className='col-home'>
                <div className='thumb'>
                  <img
                      src="./img/mouse1.jpg"
                      className="img-fluid"
                      alt="#"
                    />
                </div>
              </div>
            </div>

            <div className='col-md-6'>
              <div className='dflex-center' style={{maxWidth: '80%'}}>
                <div className='col-home mt-md-0 mt-5'>
                  <div className='heading'>Earn without investment</div>
                  <div className='content link__social' style={{maxWidth: '80%'}}>
                    Complete and detailed instruction for new users. We help in all matters, and not just we untwist something, but you give us a percentage!
                    <br/>
                    <br/>
                    We will deal with advertising and driving traffic.
                    Guaranteed income in a month after adding the first video.
                    Register for an account or provide a link to an existing one on PornHub, we will launch ads on your channel, and you will start earning on the views and subscribers that will come to your channel as a result of our advertising. For new clients, the terms of cooperation are 50/50%. You do not need to invest anything and transfer access to your account, just give us a public link, and together we will start making money.
                    <br/>d
                    No investment on your part.
                    No transfer of personal information and data, only your wallet will be linked to your account.
                    Just create an account and add a video
                    <br/>
                    <br/>
                    You will see the result of visiting your profile immediately. Withdrawal of funds is the beginning of each month, the minimum withdrawal is from $ 100, so we are interested in the quality of execution from our side
                    <br/>
                    <br/>
                    If the channel already exists the amount of 1000 $
                    <br/>
                    <br/>
                    To confirm our capabilities, we can make a test and within just one day you will see a change!
                    Details by mail or telegram:
                    <br/><a href="https://t.me/tomasbrown">Telegram: @tomasbrown</a>
                    <br/><a href="mailto:btom07459@gmail.com">Mail: btom07459@gmail.com</a>
                  </div>
                  <ul className='list-home'>
                    <li>Give us a public link only</li>
                    <li>No investment on your part</li>
                    {/*<li>Register an account or add an existing one</li>*/}
                    <li>Just create an account and add a video</li>
                    <li>Details by mail or telegram</li>
                  </ul>
                </div>
              </div>
            </div>
            
          </div>
        </section>
);
